import { api } from "../utilites/api";
import { UserPreference } from "../models/user-preference-interface";

export const UserPreferenceApi = {
  getCurrentUserPreferenceValueForApplication: (application: string, key: string) => api.get(`userpreference/single/${application}/${key}`),
  patchSingleUserPreference: (data: UserPreference) => api.patch('userpreference/single', data),
}